import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getSettings } from "./actions";

export const settingEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = settingEntityAdapter.getInitialState({
  count: 0,
  modals: {},
});

export const setting = createSlice({
  name: "setting",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSettings.fulfilled, (state, action) => {
      if (action.payload.success) {
        settingEntityAdapter.setOne(state, action.payload.setting);
      }
    });
  },
});

export default setting.reducer;
